module.exports = __webpack_public_path__ + "../resources/images/heart-4240450b46a13266d7688639a40cf8e3.svg";